<template>
  <div>
    <img alt="Vue logo" width="1024" src="../assets/home.jpg">
  </div>
</template>

<script>
export default {
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
